const doc = [({"en":({"js":({"admin":({"reimbursements":({"attachments":({"my_attachments":"My attachments", "all_attachments":"All attachments"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;